export const baseUrl = 'https://www.chefteng.com/api';

export const loginPage = '/orders';	// the page after users log in
export const logoutPage = '/';	// the page after users log out

export const DEFAULT_ERROR_MSG = '';

export const ECPAY_URL = 'https://payment.ecpay.com.tw/Cashier/AioCheckOut/V5';